import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(fas, far, fab)

interface IconProps {
  name: any
  className?: string
  toolTip?: string
  onClick?: any
  children?: any
}

const notSolidIcons = [
  'Claims',
  'Clipboard',
  'SquarePlus',
  'FileWord',
  'FilePdf',
  'FileImage',
  'FileExcel',
  'FileVideo',
  'FileImage',
  'Bell',
  'ChessKing',
  'FileLines',
  'PaperPlane',
  'TrashCan',
  'Comment',
  'Heart',
  'Map',
]

const Icon = ({ name, className = '', toolTip, onClick }: IconProps) => {
  const isNotSolid = notSolidIcons.includes(name)
  const isBrand = name === 'Instagram' || name === 'Tiktok'

  return (
    <span className={`icon ${className} icon-${name}`}>
      <FontAwesomeIcon title={toolTip} icon={isBrand ? fab['fa' + name] : isNotSolid ? far['fa' + name] : fas['fa' + name]} onClick={onClick} />
    </span>
  )
}

export default Icon
